import type { ColumnDef } from "@tanstack/react-table";
import { RTKQueryErrorAlert } from "@/shared/components/domain/errors/rtk-query-error-alert";
import {
  DataTable,
  DataTableContainer,
  useDataTableController,
} from "@/shared/components/data-table";
import { AirSampler } from "@/services/backend/airsamplers/air-sampler";
import { useListAirSamplersQuery } from "@/services/backend/airsamplers/service";
import EditAirSamplerDialog from "./edit-air-sampler-dialog";
import DeleteAirSamplerButton from "./delete-air-sampler-button";

const tableColumns: ColumnDef<AirSampler>[] = [
  {
    id: "description",
    accessorKey: "description",
    header: "Beschreibung",
    cell: ({ row }) => {
      const airSamplerData = row.original;
      return <div>{airSamplerData.description}</div>;
    },
  },
  {
    id: "holeCount",
    accessorKey: "holeCount",
    header: "Lochzahl",
    cell: ({ row }) => {
      const airSamplerData = row.original;
      return <div>{airSamplerData.holeCount}</div>;
    },
  },
  {
    id: "Optionen",
    accessorKey: "id",
    header: "Optionen",
    cell: ({ row }) => (
      <div className="flex flex-row items-center space-x-2">
        <EditAirSamplerDialog airSampler={row.original} />
        <DeleteAirSamplerButton airSamplerId={row.original.id} />
      </div>
    ),
  },
];

export function AirSamplersTable() {
  const {
    data: list,
    isLoading,
    isFetching,
    error,
  } = useListAirSamplersQuery(
    { limit: 0, offset: 0 },
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const table = useDataTableController(tableColumns, list?.items || []);

  if (error) {
    return <RTKQueryErrorAlert error={error} />;
  }

  return (
    <DataTableContainer>
      <DataTable
        table={table}
        columns={tableColumns}
        isLoading={isLoading || isFetching}
      />
    </DataTableContainer>
  );
}
